import z, { css as c } from "styled-components";
import { breakpoints as l } from "./atoms-v2125.js";
import { Base as M } from "./atoms-v2777.js";
const C = z.div`
  ${M}
  --colspan: ${({ $span: o }) => o};

  ${({ $autoFill: o }) => o ? c`
          flex-grow: 1;
        ` : c`
          flex-basis: var(--width);
        `}
  flex-shrink: 0;

  ${({ $offset: o }) => {
  if (o) {
    if (typeof o == "number")
      return c`
          margin-left: calc(
            (100% - ((var(--columns) - 1) * var(--gap))) * (${o} / var(--columns)) +
              (var(--gap) * ${o})
          );
        `;
    if (o && typeof o == "object" && Object.keys(o).length > 0)
      return Object.keys(o).map((p) => {
        const n = o[p];
        return c`
            @media ${l[p]} {
              margin-left: calc(
                (100% - ((var(--columns) - 1) * var(--gap))) * (${n} / var(--columns)) +
                  (var(--gap) * ${n})
              );
            }
          `;
      });
  }
}}

  ${({ $debug: o, $isGridVisible: p, theme: n }) => o && p && c`
      position: relative;

      &::before {
        background-color: ${n == null ? void 0 : n.get("tokens.colors.error.60")};
        color: ${n == null ? void 0 : n.get("tokens.colors.base.white")};
        font-family: 'Monaspace Neon Selfbook', 'Monaspace Neon', monospace;
        font-size: 11px;
        left: 0;
        padding: 3px 6px;
        pointer-events: none;
        position: absolute;
        top: 0;
        z-index: 10;
      }

      &::after {
        box-shadow: inset 0 0 0 1px ${n == null ? void 0 : n.get("tokens.colors.error.20")};
        content: '';
        inset: 0;
        pointer-events: none;
        position: absolute;
        z-index: 10;
      }
    `}

	${({
  $autoFill: o,
  $bleed: p,
  $colGap: n,
  $columns: x,
  $debug: j,
  $isGridVisible: k,
  $large: i,
  $max: t,
  $maxPlus: g,
  $medium: b,
  $offset: s,
  $small: u,
  $span: w,
  $xLarge: v,
  theme: a
}) => Object.keys(l).map((r) => {
  const $ = p ? a == null ? void 0 : a.get(`tokens.breakpoints.${r}.margin`) : 0, e = u && r === "small" && u || b && r === "medium" && b || i && r === "large" && i || v && r === "xLarge" && v || t && r === "max" && t || g && r === "maxPlus" && g || w, d = (
    // eslint-disable-next-line no-nested-ternary
    s && typeof s == "number" ? s : s && typeof s == "object" && Object.keys(s).length > 0 && s[r] || 0
  ), O = o ? "Autofill" : e, f = d !== 0 ? ` (→${d})` : "";
  return c`
        @media ${l[r]} {
          --colspan: ${e};
          --columns: ${x || (a == null ? void 0 : a.get(`tokens.breakpoints.${r}.columns`))};
          --gap: ${typeof n == "number" ? n : a == null ? void 0 : a.get(`tokens.breakpoints.${r}.gutter`)}px;
          --width: calc(
            (
                (100% - (var(--gap) * (var(--columns) - 1))) * ((var(--colspan) / var(--columns))) +
                  (var(--gap) * (var(--colspan) - 1))
              ) + ${$}px
          );
          ${j && k && c`
            &::before {
              content: '${O}${f}';
            }
          `};
        }
      `;
})}
`;
export {
  C as Column
};
